export default __webpack_public_path__ + "static/media/krypton.8fa8d151.png";